export const RightSideContent = ({children}) => {
    return (
        <div className="right-side-content col-6 px-2">
            <div className="background-right-container rounded">
                {children}
            </div>
        </div>
    )
}